// extracted by mini-css-extract-plugin
export var avatar = "_p0-3";
export var avatarContainer = "_p0-2";
export var avatarSpacer = "_p0-5";
export var avatarSpacerContainer = "_p0-4";
export var avatarStackContainer = "_p0-1";
export var bubble = "_p0-0";
export var remainderBubble = "_p0-6";